import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const GenericGuideSeparator = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-separator'></div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideSeparator);